import { render } from "./down.vue?vue&type=template&id=4fb66198&scoped=true&ts=true&lang=pug"
import script from "./down.vue?vue&type=script&lang=ts"
export * from "./down.vue?vue&type=script&lang=ts"

import "./down.vue?vue&type=style&index=0&id=4fb66198&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb66198"]])

export default __exports__